<template>
  <div class="box">
    <div class="wrap" data-spy="scroll" data-target="#selector" data-offset="120">
      <nav id="selector">
        <div class="imgs">
          <img src="../img/header-txm.png" alt />
        </div>
        <ul class="nav">
          <span></span>
          <li class="active">
            <a href="#tab1">首页</a>
          </li>
          <li>
            <a href="#tab2">核心功能</a>
          </li>
          <li>
            <a href="#tab3">团队介绍</a>
          </li>
          <li>
            <a href="#tab4">合作品牌</a>
          </li>
          <li>
            <a href="#tab5">联系我们</a>
          </li>
        </ul>
        <div class="login">
          <button @click="login">立即登录</button>
        </div>
      </nav>
      <div class="header-login">
        <img src="../img/header-login.png" alt :style="{'display':this.loginstatus?'block':'none'}" />
        <span class="cacel" @click="cacel" :style="{'display':this.loginstatus?'block':'none'}"></span>
      </div>
      <!-- 手机端的头部 -->
      <div class="model-nav">
        <div class="model-txm">
          <img src="../img/header-txm.png" alt />
        </div>
        <div class="model-select" @click="list">
          <img src="../img/list.png" alt />
        </div>
        <div
          :class="['nav-tabs',this.liststatus?'fadeIn ':'fadeInUp']"
          id="selector a"
          :style="{'display':this.liststatus?'block':'none'}"
        >
          <ul @click="list">
            <li class="active">
              <a href="#tab1">首页</a>
            </li>
            <li>
              <a href="#tab2">核心功能</a>
            </li>
            <li>
              <a href="#tab3">团队介绍</a>
            </li>
            <li>
              <a href="#tab4">合作品牌</a>
            </li>
            <li>
              <a href="#tab5">联系我们</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="section">
        <!-- pc端侧边固定的二维码 -->
        <div id="bar_float" :style="{display:this.asideCode?'block':'none'}">
          <span class="close_cacel" @click="asideCacelCode"></span>
          <img src="../img/code-aside.png" alt />
        </div>
        <!-- pc端的轮播图 -->
        <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
          <!-- Wrapper for slides -->
          <div class="carousel-inner" role="listbox" id="tab1">
            <div class="item active" style="padding-top:100px;margin-top:-20px">
              <img src="../img/section-1.jpg" alt="..." />
            </div>
            <div class="item" style="padding-top:100px;margin-top:-20px">
              <img src="../img/section-2.jpg" alt="..." />
            </div>
            <div class="wather1">
              <img src="../img/whater-1.png" alt />
            </div>
            <div class="wather2">
              <img src="../img/whater-2.png" alt />
            </div>
          </div>
          <!-- Controls -->
          <a
            class="left carousel-control"
            href="#carousel-example-generic"
            role="button"
            data-slide="prev"
          >
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
          </a>
          <a
            class="right carousel-control"
            href="#carousel-example-generic"
            role="button"
            data-slide="next"
          >
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
          </a>
        </div>
        <!-- 手机端的轮播图 -->
        <div class="swiper-container" id="tab1" style="padding-top:100px;">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="../img/model-swiper1.jpg" alt />
            </div>
            <div class="swiper-slide">
              <img src="../img/model-swiper2.jpg" alt />
            </div>
          </div>
          <div class="swiper-pagination page" style="bottom:70px;z-index:999"></div>
          <div class="wather1">
            <img src="../img/whater-1.png" alt />
          </div>
          <div class="wather2">
            <img src="../img/whater-2.png" alt />
          </div>
        </div>
        <div class="icon-bar">
          <div class="introdution">VIDEO INTRODUCTION</div>
          <div class="video">视频介绍</div>
        </div>
        <div class="model">
          <div class="model-box">
            <video
              src="../img/video-model.mp4"
              autoplay="autoplay"
              loop="loop"
              id="video"
              style="width:100%;height:100%;object-fit:fill"
              webkit-playsinline="true"
              x-webkit-airplay="true"
              playsinline="true"
              x5-video-player-type="h5"
              x5-video-orientation="h5"
              x5-video-player-fullscreen="true"
              preload="auto"
              x5-playsinline
            ></video>
            <div class="status" @click="changeStatus">
              <img src="../img/start.png" alt id="img1" style />
              <img src="../img/pause.png" alt id="img2" style="display:none" />
            </div>
          </div>
        </div>
        <div class="icon-bar function" id="tab2" style="padding-top:100px;">
          <div class="introdution">PRODUCT FEATURES</div>
          <div class="video">产品功能</div>
        </div>
        <div class="product">
          <img src="../img/function-1.png" alt />
          <img src="../img/function-2.png" alt />
          <img src="../img/function-3.png" alt />
          <img src="../img/function-4.png" alt />
          <br />
          <img src="../img/function-5.png" alt />
          <img src="../img/function-6.png" alt />
          <img src="../img/function-7.png" alt />
          <img src="../img/function-8.png" alt />
        </div>
        <!-- pc端的立即使用 -->
        <div class="immediate-use-a">
          <img src="../img/immediate-use.png" alt class="ab" />
          <span class="span-immediate" @click="immediateUse"></span>
          <img
            src="../img/scanCode .png"
            alt
            class="txm-img"
            :style="{display:this.scancodeStatus?'block':'none'}"
          />
          <span
            class="txm-ca"
            @click="immediatecacel"
            :style="{display:this.scancodeStatus?'block':'none'}"
          ></span>
        </div>
        <!-- 手机端的立即使用 -->
        <div class="user">
          <img src="../img/model-user.png" alt />
          <span class="model-span-immediate" @click="immediateUse"></span>
        </div>
        <div class="error-span">
          <img
            src="../img/scanCode .png"
            alt
            class="model-txm-img"
            :style="{display:this.scancodeStatus?'block':'none'}"
          />
          <span
            class="model-txm-ca"
            @click="immediatecacel"
            :style="{display:this.scancodeStatus?'block':'none'}"
          ></span>
        </div>
        <div class="icon-bar team" id="tab3" style="padding-top:100px;margin-top: 0px;">
          <div class="introdution">TEAM INTRODUCTION</div>
          <div class="video">团队介绍</div>
        </div>
        <!-- pc端的团队介绍 -->
        <div class="teamproduct" id="tab3" style="padding-top:100px;">
          <div class="all">
            <div class="pink-line"></div>
            <div
              class="team-product"
            >团小蜜是独到科技（北京）有限公司开发的一款产品，公司成立于2012年，投资方为招商局和IDG资本，公司背靠清华大学人工智能研究院，核心团队由清华大学计算机专业人工智能方向博士组成，团队成员包括清华姚班毕业生、人工智能博士、腾讯、微软等行业专家。</div>
          </div>
          <img src="../img/team.png" alt class="team-img" />
        </div>
        <!-- 手机端的团队介绍 -->
        <div class="model-team-qh" id="tab3" style="padding-top:100px;margin-top:-80px;">
          <img src="../img/team.png" alt class="team-img" />
          <div class="all">
            <div class="pink-line"></div>
            <div
              class="team-product"
            >团小蜜是独到科技（北京）有限公司开发的一款产品，公司成立于2012年，投资方为招商局和IDG资本，公司背靠清华大学人工智能研究院，核心团队由清华大学计算机专业人工智能方向博士组成，团队成员包括清华姚班毕业生、人工智能博士、腾讯、微软等行业专家。</div>
          </div>
        </div>
        <div class="icon-bar brand" id="tab4" style="padding-top:100px;">
          <div class="introdution">COOPERATIVE BRAND</div>
          <div class="video">合作品牌</div>
        </div>
        <div class="Cooperative">
          <div class="brand-img1">
            <img src="../img/brand-1.png" alt />
            <img src="../img/brand-2.png" alt />
            <img src="../img/brand-3.png" alt />
            <img src="../img/brand-4.png" alt />
          </div>
          <div class="brand-img2">
            <img src="../img/brand-5.png" alt />
            <img src="../img/brand-6.png" alt />
            <img src="../img/brand-7.png" alt />
            <img src="../img/brand-8.png" alt />
          </div>
        </div>
      </div>
      <div class="footer" id="tab5">
        <div class="mine">
          <span>
            <a href="#tab1">首页</a>
          </span>
          <span>
            <a href="#tab2">核心功能</a>
          </span>
          <span>
            <a href="#tab3">团队介绍</a>
          </span>
          <span>
            <a href="#tab4">合作品牌</a>
          </span>
          <span>
            <a href="#tab5">联系我们</a>
          </span>
        </div>
        <div class="contact">
          <div class="footer-txm">
            <img src="../img/footer-txm.png" alt />
          </div>
          <div class="detail">
            <span>商务合作：contact@doodod.com</span>
            <span>地址：北京市海淀区五道口优盛大厦</span>
            <span>打造你自己的品牌团购 让智能AI帮你卖货</span>
          </div>
          <div class="code">
            <dl>
              <dt>
                <img src="../img/footer-commander.png" alt />
              </dt>
              <dd>申请团长： 18618406635</dd>
            </dl>
            <dl>
              <dt>
                <img src="../img/footer-Supplier.png" alt />
              </dt>
              <dd>供货商：15201397816</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
  data() {
    return {
      loginstatus: false,
      scancodeStatus: false,
      screenstatus: "",
      liststatus: false,
      asideCode:true
    };
  },

  mounted() {
    let swiper = new Swiper(".swiper-container", {
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: true
      },
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        el: ".swiper-pagination"
      },
      autoplayDisableOnInteraction: false,
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
  },
  methods: {
    // 取消侧边二维码
    asideCacelCode(){
      console.log(11)
      if (this.asideCode) {
        this.asideCode = false;
      } else {
        this.asideCode = true;
      }
    },
    list() {
      if (this.liststatus) {
        this.liststatus = false;
      } else {
        this.liststatus = true;
      }
    },
    // 立即登陆
    login() {
      if (this.loginstatus) {
        this.loginstatus = false;
      } else {
        this.loginstatus = true;
      }
    },
    // 点击❎
    cacel() {
      if (this.loginstatus) {
        this.loginstatus = false;
      } else {
        this.loginstatus = true;
      }
    },
    // 立即使用
    immediateUse() {
      if (this.scancodeStatus) {
        this.scancodeStatus = false;
      } else {
        this.scancodeStatus = true;
      }
    },
    //
    immediatecacel() {
      console.log(111);
      if (this.scancodeStatus) {
        this.scancodeStatus = false;
      } else {
        this.scancodeStatus = true;
      }
    },
    changeStatus() {
      let vid = document.getElementById("video");
      //false 点击了播放  true 点击了暂停
      if (vid.paused === true) {
        //暂停
        setInterval(function() {
          document.getElementById("img1").style.opacity = "0";
        }, 3000);
        document.getElementById("img1").style.display = "block";
        document.getElementById("img2").style.display = "none";
        vid.play();
      } else {
        document.getElementById("img1").style.display = "none";
        document.getElementById("img2").style.display = "block";
        vid.pause();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@media screen and(min-width:850px) {
  #selector .nav li {
    flex: 2;
    a {
      text-align: center;
    }
  }
  .error-span {
    display: none;
  }
  .model-txm-img {
    display: none;
  }
  .box {
    position: relative;
  }
  .wrap {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .model-nav {
    display: none;
  }
  .user {
    display: none;
  }
  .model-team-qh {
    display: none;
  }
  nav {
    width: 100%;
    background-color: white;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
  }
  .swiper-container {
    display: none;
  }
  #selector {
    display: flex;
    width: 100%;
    .imgs {
      flex: 4;
      img {
        transform: scale(0.6);
      }
    }
    .nav {
      flex: 5;
      display: flex;
      line-height: 100px;
      margin-right: 44px;
      span {
        flex: 3;
      }
      li {
        flex: 1;
        text-align: right;
      }
      li a {
        display: inline;
        padding: 0 0;
        color: rgba(76, 76, 76, 1);
      }
      a:hover {
        color: rgba(251, 42, 158, 1);
        cursor: pointer;
        background: none;
        border: 0;
      }
      li > a:hover::after {
        content: "";
        width: 100%;
        position: absolute;
        left: 0px;
        bottom: -3px;
        right: 0;
        height: 2px;
        background: rgba(251, 42, 158, 1);
      }
    }
    .login {
      text-align: left;
      flex: 2;
      button {
        width: 88px;
        height: 34px;
        background: rgba(255, 200, 248, 1);
        border-radius: 17px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(251, 42, 224, 1);
        border: 0;
        outline: 0;
        margin: 30px 0;
      }
    }
  }
  .header-login {
    position: fixed;
    right: 125px;
    top: 90px;
    z-index: 999;
    display: block;
    width: 400px;
    img {
      width: 100%;
    }
    .cacel {
      width: 120px;
      height: 120px;
      position: absolute;
      top: 16px;
      right: 0;
      opacity: 0;
    }
  }
  .nav-tabs .login {
    width: 88px;
    height: 34px;
    background: rgba(255, 200, 248, 1);
    border-radius: 17px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(251, 42, 224, 1);
    border: 0;
    outline: 0;
    margin: 23px 0;
  }
  .nav-tabs .header-login {
    transform: scale(0.38);
    height: 150px;
    position: absolute;
    top: 35px;
    right: -343px;
    display: block;
  }
  .nav-tabs .header-login img {
    width: 100%;
  }
  .nav-tabs .section-box {
    width: 100%;
  }
  .carousel-inner {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .section #bar_float {
    width: 250px;
    height: 291px;
    position: fixed;
    z-index: 9999;
    right: 65px;
    top: 60%;
    img {
      display: block;
      width: 250px;
      height: 291px;
    }
    .close_cacel{
      width: 33px;
      height: 30px;
      position: absolute;
      top: 0;
      right: 24px;
    }
  }
  .section .swiper-container {
    width: 100%;
    height: 100%;
  }
  .carousel-inner img {
    width: 100%;
    height: 100%;
  }
  .wather1 {
    background-image: url("../img/whater-1.png") n0;
    width: 150%;
    position: absolute;
    bottom: -1px;
    z-index: 99;
    animation: move_wave 2s;
    -webkit-animation: move_wave 2s;
    -webkit-animation-delay: 100s;
    animation-delay: 2s;
    animation: move_wave 50s infinite ease-in-out;
  }
  .wather2 {
    width: 150%;
    position: absolute;
    bottom: -1px;
    z-index: 99;
    animation: move_wave 50s infinite ease-in-out;
  }
  @keyframes move_wave {
    25% {
      transform: translateX(-10%) translateZ(0);
    }
    50% {
      transform: translateX(-25%) translateZ(-500px);
    }
    100% {
      transform: translateX(-100%) translateZ(300%);
    }
  }
  .icon-bar {
    width: 100%;
    height: 84px;
    // margin: 0 auto;
    margin-top: 80px;
  }
  .introdution {
    // margin-top: -80px;
    color: rgba(240, 240, 240, 1);
    font-size: 60px;
    font-weight: 600;
    -webkit-text-stroke: 1px rgba(240, 240, 240, 1);
    text-stroke: 1px rgba(240, 240, 240, 1);
  }
  .video {
    margin-top: -49px;
    font-size: 50px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    border: 0;
    outline: none;
    cursor: pointer;
  }
  .model {
    width: 100%;
    height: 640px;
  }
  .model-box {
    margin: 0 auto;
    margin-top: 50px;
    width: 368px;
    height: 640px;
    background: rgba(255, 255, 255, 1);
    border-radius: 30px;
    position: relative;
  }
  .model-box img {
    position: absolute;
    top: 285px;
    left: 149px;
    width: 70px;
    height: 70px;
  }
  .model-box video {
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
    border-radius: 30px;
    outline: none;
    border: 0;
  }

  .product {
    width: 100%;
    // height: 326px;
    margin: 0 auto;
    margin-top: 150px;
  }
  .product > img {
    width: 285px;
    height: 150px;
    margin-top: 13px;
    margin-right: 10px;
  }
  .immediate-use-a {
    width: 100%;
    height: auto;
    margin-top: 99px;
    position: relative;
  }
  .immediate-use-a img {
    width: 100%;
    height: 100%;
  }
  .immediate-use-a .txm-img {
    width: 416px;
    height: 492px;
    position: absolute;
    top: -50%;
    left: 39%;
    z-index: 999;
  }

  .txm-ca {
    width: 150px;
    height: 150px;
    position: absolute;
    top: -62%;
    left: -50%;
    z-index: 99999;
    left: 57%;
  }
  .immediate-use-a .span-immediate {
    width: 198px;
    height: 53px;
    position: absolute;
    top: 56%;
    left: 44.9%;
    opacity: 0;
  }
  .immediate-use .ab {
    width: 100%;
    height: 100%;
  }
  .function {
    margin-top: 86px;
  }
  .team {
    margin-top: 80px;
  }
  .teamproduct {
    width: 100%;
    height: 344px;
    margin-top: 57px;
  }
  .teamproduct .all {
    width: 529px;
    height: 305px;
    display: inline-block;
    position: relative;
    margin-right: 95px;
  }
  .teamproduct .pink-line {
    margin: 0 auto;
    position: absolute;
    top: 62px;
    left: 0px;
    width: 43px;
    height: 6px;
    background: rgba(251, 42, 158, 1);
    display: inline-block;
  }
  .teamproduct .team-product {
    text-align: left;
    width: 529px;
    height: 228px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    margin-top: 88px;
    display: inline-block;
  }
  .team-img {
    margin: 0 auto;
    width: 535px;
    height: 344px;
    display: inline-block;
    vertical-align: top;
  }
  .Cooperative {
    width: 100%;
    margin: 0 auto;
    margin-top: 149px;
  }
  .Cooperative .brand-img1,
  .Cooperative .brand-img2 {
    width: 100%;
  }
  .Cooperative .brand-img1 img,
  .Cooperative .brand-img2 img {
    width: 277px;
    border-radius: 6px;
  }
  .footer {
    width: 100%;
    height: 200px;
    margin-top: 108px;
    margin: 0 auto;
  }
  .mine {
    width: 100%;
    height: 50px;
    background: rgba(35, 35, 35, 1);
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 50px;
    margin-top: 108px;
  }
  .mine span {
    border-right: 1px solid rgba(255, 255, 255, 0.2);
  }
  .mine span a {
    text-decoration: none;
  }
  .mine span:last-child {
    border-right: 0;
  }
  .mine span a {
    color: rgba(255, 255, 255, 1);
    padding: 17px 57px 16px 95px;
  }
  .contact {
    width: 100%;
    height: 150px;
    background: rgba(46, 46, 46, 1);
  }
  .footer-txm {
    margin: 0 auto;
    width: 100px;
    height: 60px;
    display: inline-block;
    border-right: 1px solid rgba(255, 255, 255, 0.19);
  }
  .footer-txm img {
    width: 50px;
    margin: 5px 0;
    vertical-align: text-bottom;
    margin-right: 38px;
    display: inline-block;
  }

  .detail {
    display: inline-block;
    margin-left: 39px;
    margin-right: 525px;
  }
  .detail span {
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.49);
    display: block;
    text-align: left;
  }
  .detail span:nth-child(1) {
    margin-top: 39px;
  }
  .detail span:nth-child(2) {
    margin: 12px 39px 10px 0;
  }
  .code {
    margin: 0 auto;
    margin-top: 24px;
    display: inline-block;
  }
  .code dl {
    display: inline-block;
    margin-right: 23px;
  }
  .code dl dt img {
    width: 78px;
    height: 80px;
  }
  .code dl dt {
    margin-bottom: 9px;
  }
  .code dl dd {
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.59);
  }
  .swiper-button-prev:after,
  .swiper-button-next:after {
    content: "" !important;
  }
  .swiper-button-prev img,
  .swiper-button-next img {
    width: 40px !important;
    height: 40px !important;
    display: block;
  }

  .immediate-use .txm-img {
    position: absolute;
    width: 416px;
    height: 492px;
    display: inline-block;
    top: -38%;
    left: 41%;
  }
  .immediate-use {
    width: 80px;
    height: 80px;
    top: -32%;
    left: 58%;
    background: pink;
    position: absolute;
    opacity: 0;
  }
  // 去除轮播的阴影
  .carousel-control.left {
    background-image: none;
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);
  }
  .carousel-control.right {
    left: auto;
    right: 0;

    background-image: none;
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);
  }
  .carousel > .left,
  .carousel > .right {
    background-image: none;
  }
  .swiper-button-prev {
    left: 100px !important;
  }
  .swiper-button-next {
    right: 100px !important;
  }
  @media screen and(max-width:1200px) {
    .detail {
      margin-right: 100px;
    }
  }
}
@media screen and(max-width:849px) {
  body,
  html {
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
  }
  #app {
    width: 100%;
    height: 100%;
  }
  .wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  #bar_float {
    display: none!important;
  }
  nav {
    display: none;
  }

  .teamproduct {
    display: none;
  }
  .header-login {
    display: none;
  }
  #carousel-example-generic {
    display: none;
  }
  .immediate-use-a {
    display: none;
  }
  .model-nav {
    width: 100%;
    height: 80px;
    padding: 0 30px;
    line-height: 80px;
    position: relative;
    position: fixed;
    top: 0px;
    left: 0;
    background-color: white;
    z-index: 9999999999;

    .model-txm {
      width: 198px;
      height: 50px;
      display: inline-block;
      float: left;
      img {
        width: 100%;
        height: 100%;
        display: inline-block;
      }
    }
    .model-select {
      width: 42px;
      height: 25px;
      display: inline-block;
      float: right;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .nav-tabs {
      width: 100%;
      height: 366px;
      position: absolute;
      top: 80px;
      left: 0;
      z-index: 99;
      background: white;
      text-align: left;
      padding-left: 30px;
      transition: all 1.5s ease;
      li {
        height: 30px;
        font-size: 26px;
        font-weight: 400;
        margin-top: 35px;
        display: block;
        a {
          position: relative;
          color: rgba(76, 76, 76, 1);
          text-decoration: none;
        }
        a:hover {
          color: rgba(251, 42, 158, 1);
          cursor: pointer;
          background: rgba(255, 255, 255, 1);
        }
      }
    }
  }
  .swiper-container {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
    .swiper-pagination /deep/.swiper-pagination-bullet {
      bottom: 120px;
      left: 0;
      width: 100%;
      width: 35px;
      height: 8px;
      background: rgba(255, 255, 255, 1);
      border-radius: 6px;
    }
  }
  .wather1 {
    width: 300%;
    position: absolute;
    bottom: -2px;
    z-index: 99;
    animation-delay: 2s;
    animation: move_wave 40s infinite linear;
  }
  .wather2 {
    width: 300%;
    position: absolute;
    bottom: -1px;
    z-index: 99;
    animation-delay: 2s;
    animation: move_wave 40s infinite linear;
  }
  @keyframes move_wave {
    25% {
      transform: translateX(-10%) translateZ(0);
    }
    50% {
      transform: translateX(-25%) translateZ(-500px);
    }
    100% {
      transform: translateX(-100%) translateZ(300%);
    }
  }
  .icon-bar {
    width: 100%;
    margin-top: 25px;
    .introdution {
      color: rgba(240, 240, 240, 1);
      font-size: 44px;
      font-weight: 600;
      -webkit-text-stroke: 1px rgba(240, 240, 240, 1);
      text-stroke: 1px rgba(240, 240, 240, 1);
      display: inline;
    }
    .video {
      margin-top: -31px;
      font-size: 34px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      border: 0;
      outline: none;
      cursor: pointer;
    }
  }
  .model {
    width: 100%;
    height: 640px;
    margin-top: 93px;
  }
  .model-box {
    margin: 0 auto;
    margin-top: 38px;
    width: 368px;
    height: 640px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
    border-radius: 30px;
    position: relative;
  }
  .model-box img {
    position: absolute;
    top: 285px;
    left: 149px;
    width: 70px;
    height: 70px;
  }
  .model-box video {
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
    border-radius: 30px;
    outline: none;
    border: 0;
  }
  .product {
    width: 100%;
    height: auto;
    margin-top: 40px;
    img {
      margin: 0 auto;
      margin-top: 40px;
      width: 285px;
      height: 150px;
      border-radius: 4px;
    }
  }

  .team-img {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    padding: 0 87px;
    margin-top: 100px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .all {
    width: 100%;
    height: auto;
    display: inline-block;
    position: relative;
    padding: 0 50px;
    margin-right: 95px;
  }
  .pink-line {
    margin: 0 50px;
    position: absolute;
    top: 62px;
    left: 0px;
    width: 43px;
    height: 6px;
    background: rgba(251, 42, 158, 1);
    display: inline-block;
  }
  .team-product {
    text-align: left;
    width: 100%;
    height: 190px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    margin-top: 88px;
    display: inline-block;
  }
  .Cooperative {
    width: 100%;
    margin: 0 auto;
    margin-top: 52px;
  }
  .Cooperative img {
    width: 277px;
    border-radius: 6px;
  }
  .user {
    width: 100%;
    height: 100%;
    margin-top: 70px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .model-span-immediate {
      width: 150px;
      height: 60px;
      position: absolute;
      top: 49%;
      left: 36%;
      // opacity: 0;
    }
  }
  .error-span {
    width: 100%;
    height: 150px;
    position: absolute;
    .model-txm-img {
      width: 300px;
      margin: 0 auto;
      margin-top: -295px;
    }
    .model-txm-ca {
      width: 100px;
      height: 100px;
      margin-top: -381px;
      position: absolute;
      margin-left: 220px;
      left: 20%;
    }
  }

  .footer {
    width: 100%;
    height: auto;
    margin: 0 auto;
    a {
      color: white;
    }
    .mine {
      width: 100%;
      height: auto;
      background: rgba(35, 35, 35, 1);
      font-size: 12px;
      font-weight: 400;
      line-height: 50px;
      margin-top: 80px;
    }
    .mine span {
      text-align: left;
      display: block;
      height: 40px;
      line-height: 40px;
    }
    .mine span a {
      text-decoration: none;
      padding: 5px 0px 5px 10px;
    }
    .contact {
      width: 100%;
      height: auto;
      background: rgba(46, 46, 46, 1);
    }
    .footer-txm {
      width: 78px;
      height: 60px;
      display: inline-block;
      margin-left: 25px;
      border-right: 1px solid rgba(255, 255, 255, 0.19);
    }
    .footer-txm img {
      width: 50px;
      height: 50px;
      margin: 5px 0;
      vertical-align: text-bottom;
      margin-right: 38px;
      display: inline-block;
    }

    .detail {
      display: inline-block;
      margin-left: 12px;
      margin-right: 0;
    }
    .detail span {
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.49);
      display: block;
      text-align: left;
    }
    .detail span:nth-child(1) {
      margin-top: 39px;
    }
    .detail span:nth-child(2) {
      margin: 12px 39px 10px 0;
    }
    .code {
      margin: 0 auto;
      margin-top: 24px;
      display: inline-block;
    }
    .code dl {
      display: inline-block;
      margin-right: 23px;
    }
    .code dl dt img {
      width: 78px;
      height: 80px;
    }
    .code dl dt {
      margin-bottom: 9px;
    }
    .code dl dd {
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.59);
    }
    .swiper-button-prev:after,
    .swiper-button-next:after {
      content: "" !important;
    }
    .swiper-button-prev img,
    .swiper-button-next img {
      width: 40px !important;
      height: 40px !important;
      display: block;
    }
    .swiper-button-prev {
      left: 153px !important;
    }
    .swiper-button-next {
      right: 153px !important;
    }

    .immediate-use .txm-img {
      position: absolute;
      width: 416px;
      height: 492px;
      display: inline-block;
      top: -38%;
      left: 41%;
    }
    .immediate-use {
      width: 80px;
      height: 80px;
      top: -32%;
      left: 58%;
      background: pink;
      position: absolute;
      opacity: 0;
    }
  }
}
@media (max-width: 500px) and(min-width:0px) {
  .model-nav .nav-tabs {
    height: 250px;
  }

  .model-nav .nav-tabs li {
    font-size: 20px;
    margin-top: 10px;
  }
  .swiper-pagination /deep/.swiper-pagination-bullet {
    bottom: 120px;
    left: 0;
    width: 100%;
    width: 30px !important;
    height: 5px !important;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;
  }
  .model-nav {
    padding: 0 5px;
  }
  .model-nav .model-txm img {
    transform: scale(0.6);
    margin-left: -62px;
  }
  .model-nav .model-select img {
    transform: scale(0.6);
    line-height: 80px;
  }
  .team-img {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    padding: 0 10px;
    margin-top: 56px;
  }
  .icon-bar .introdution {
    font-size: 30px;
  }
  .icon-bar .video {
    margin-top: -23px;
    font-size: 26px;
  }
  .product {
    margin-top: 0;
  }
  .model {
    margin-top: 0;
    height: auto;
  }
  .model-box {
    width: 300px;
    height: 440px;
  }
  .model-box img {
    position: absolute;
    top: 183px;
    left: 117px;
    width: 70px;
    height: 70px;
  }
  .team-product {
    text-align: left;
    width: 100%;
    height: 0;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000;
    margin-top: 88px;
    display: inline-block;
  }
}
@media (max-width: 1550px) and(min-width:850px) {
  .txm-ca {
    top: -127%;
    left: 65%;
  }

  .immediate-use-a .txm-img {
    width: 416px;
    height: 492px;
    position: absolute;
    top: -132%;
    left: 26%;
    z-index: 999;
  }
  .imgs {
    flex: 1;
    img {
      width: 80%;
    }
  }
  .nav {
    flex: 7;
  }
  .header-login {
    flex: 1;
    right: -13px;
    img {
      width: 80%;
    }
  }
  #selector .nav li {
    flex: 2;
    // margin:0 12px;
  }
}
@media (max-width: 1200px) {
  .header-login {
    flex: 1;
    right: -64px;
    img {
      width: 80%;
    }
  }
}
@media screen and (max-width: 400px) {
  .error-span .model-txm-ca {
    width: 100px;
    height: 100px;
    margin-top: -381px;
    position: absolute;
    margin-left: 220px;
    left: 0;
  }
}
@media screen and (min-width: 700px) and (max-width: 850px) {
  .error-span .model-txm-ca {
    width: 100px;
    height: 100px;
    margin-top: -381px;
    position: absolute;
    margin-left: 220px;
    left: 29%;
  }
}
@media screen and (min-width: 700px) and (max-width: 1570px) {
  .immediate-use-a .txm-img {
    top: -82%;
    left: 36%;
  }
}
@media screen and (max-height: 5000px) {
  .asideCode {
    top: 520px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue